import { Database } from 'firebase/database';
import { setUserChannelPreferences } from '../services/buildfire/rdb/user';

export const COURIER_CASE_NOTIF_PREFERENCE_ID = 'JEWYX776JEMYR8M9PHVWVJVPTEGY';
export const COURIER_MESSAGE_NOTIF_PREFERENCE_ID =
  'NYKD4KTE0F4ARHH9YC88XY5ZX1EN';

export const enablePushNotificationsInDB = async (
  db: Database,
  userId: string
) => {
  return Promise.all([
    setUserChannelPreferences({
      database: db,
      userId,
      courierTemplateId: COURIER_CASE_NOTIF_PREFERENCE_ID,
      channel: 'push',
      enabled: true,
    }),
    setUserChannelPreferences({
      database: db,
      userId,
      courierTemplateId: COURIER_MESSAGE_NOTIF_PREFERENCE_ID,
      channel: 'push',
      enabled: true,
    }),
  ]);
};
